import { render, staticRenderFns } from "./Paintings.vue?vue&type=template&id=67bd878e&scoped=true&"
import script from "./Paintings.vue?vue&type=script&lang=js&"
export * from "./Paintings.vue?vue&type=script&lang=js&"
import style0 from "./Paintings.vue?vue&type=style&index=0&id=67bd878e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67bd878e",
  null
  
)

export default component.exports